import { render, staticRenderFns } from "./PublicPrograms.vue?vue&type=template&id=c084bb0a&"
import script from "./PublicPrograms.vue?vue&type=script&lang=js&"
export * from "./PublicPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports